export const product: object = {
  productDetails: {
    plansAndPricing: 'Plans and Pricing',
    pricing: 'Pricing',
    id: 'ID',
    allPlansInclude: 'All Plans include',
    pricingDetails: 'Pricing Details',
    tieredPricing: 'Tiered Pricing',
    scaleDiscount: 'Scale Discount',
    perAmountOfUnit: 'Per {{amount}} {{unit}}:',
    perUnit: 'Per {{unit}}',
    cancellationFee: 'Termination',
    oneTime: 'One Time',
    monthly: 'Monthly',
    per: 'Per',
    pricePerAmountOfUnitsPerPeriod: 'Price per {{amount}} {{unit}} per {{period}}',
    pricePerUnitPerPeriod: 'Price per {{unit}} per {{period}}',
    priceUponRequest: 'Price upon request',
    priceNotAvailable: 'Price is currently not available',
    fixPrice: 'Fix Price:',
    first: 'First',
    next: 'Next',
    cta: {
      trial: 'Try Free',
      buy: 'Get It Now',
      rfi: 'Contact Publisher',
      upsell: 'Upsell',
      upgrade: 'Upgrade',
      manageOrders: 'Contact Support',
    },
    termsConditions: {
      printTermsButton: 'Print',
      closePrintTermsButton: 'Close'
    },
    from: 'from',
    by: 'by',
    benefitsAndFeatures: 'Benefits and Features',
    benefits: 'Benefits',
    features: 'Features',
    moreBenefits: 'More Benefits',
    moreFeatures: 'More Features',
    lessBenefits: 'Less Benefits',
    lessFeatures: 'Less Features',
    technicalInformation: 'Technical Information',
    providedByPublisher: 'The information contained in this section is provided by the publisher.',
    general: 'General',
    category: 'Category',
    deployment: 'Deployment',
    operations: 'Operations',
    security: 'Security',
    compliance: 'Compliance',
    globalization: 'Globalization',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    resources: 'Resources',
    moreResources: 'More Resources',
    lessResources: 'Less Resources',
    readPdf: 'Read PDF',
    watchVideo: 'Watch Video',
    visitWebsite: 'Visit Website',
    allProducts: 'All Products',
    privacyStatement: 'Privacy Statement',
    termsAndConditions: 'Terms and Conditions',
    solution: 'Solution',
    supportPage: 'Support Page',
    contactSupport: 'Contact Support',
    contactSupportDescription: 'Create a support ticket to get assistance with a question or issue.',
    chatNow: 'Chat Now',
    chatNowDescription: 'Chat with an SAP representative to get live help.',
    chatUnavailable: 'Chat currently unavailable',
    chatUnavailableDescription: 'Chat with an SAP representative to get live help.',
    howCanHelp: 'How can we help?',
    haveQuestion: 'Have a Question?',
    contactUs: 'Contact Us',
    atAGlance: 'At a Glance',
    publisher: 'Publisher',
    askPublisher: 'Ask Publisher',
    askPublisherDescription: 'Contact the publisher to ask about this solution.',
    askSapStore: 'Ask SAP Store',
    askSapStoreDescription: 'Get help with site questions, troubleshoot, or everything else.',
    viewPublisherInformation: 'View Publisher Information',
    publisherSolutions: 'View All Solutions',
    freeTrial: 'Free Trial',
    viewAll: 'View All',
    includes: 'Includes',
    unlimited: 'unlimited',
    minDuration: '{{min}} {{unit}} min. contract duration',
    maxDuration: '{{max}} {{unit}} max. contract duration',
    minMaxDuration: '{{min}} to {{max}} {{unit}} contract duration',
    sapProduct: 'SAP Product',
    productDetails: 'Product Details',
    productLogo: 'Product logo',
    certification: 'Certification',
    freeTrialAvailable: 'Free trial',
    productName: 'Product name',
    productDetailsPage: 'Product details page for {{productName}}',
    teaserText: 'Teaser text',
    quantity: 'Quantity',
    share: 'Share',
    shipping: 'Shipping',
    showReviews: 'Show reviews',
    specification: 'Specs',
  },
  addToCart: {
    itemsAddedToYourCart: 'Item(s) added to your cart',
    itemsIncrementedInYourCart:
      'This item was already in your cart. The quantity was updated.',
    items: 'items',
    updatingCart: 'Updating Cart',
    addToCart: 'Add to cart',
    updateCart: 'Update Cart',
    viewCart: 'view cart',
    proceedToCheckout: 'proceed to checkout',
    quantity: 'Qty',
    outOfStock: 'Out of stock',
    inStock: 'In stock',
  },
  productReview: {
    reviewCount: '({{count}} reviews)',
    reviewCountEmpty: '({{count}})',
    overallRating: 'Overall Rating',
    reviewTitle: 'Review Title',
    writeYourComments: 'Write your comments',
    rating: 'Rating',
    reviewerName: 'Reviewer name (optional)',
    writeReview: 'Write a Review',
    more: 'More',
    less: 'Less',
    thankYouForReview:
      'Thank you for the review! Note that reviews may require review before appearing here.',

    outOf5Stars: 'out of 5 stars',
    beTheFirstToReview: 'Be the first to share your thoughts about this solution',
    chatBubbleOrange: 'chat bubble orange',
    continueToG2Crowd: 'Continue to G2.com',
    empty: 'empty',
    half: 'half',
    filled: 'filled',
    G2Com: 'G2.com',
    G2CrowdRedirect: 'To proceed you will be redirected to G2.com',
    reviews: 'Reviews',
    reviewsCollectedAndHosted: 'Reviews collected and hosted on',
    star: 'star',
    verifiedReviewer: 'Verified Reviewer',
    readThisReviewOnG2: 'Read this review on G2.com.',
    writeAReview: 'Write a review',
    writeAReviewUppercase: 'Write a Review',
    readAReview: 'Read The Full Review'
  },
};
